import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR410004_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: "勤務先",
    keyword: "facility",
    type: "text",
  },
  {
    title: "氏名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title:
      "被共済職員期間（合算制度を利用している場合は、前勤務先の被共済期間が合算されているか確認を行ってください。）",
    keyword: "period",
    type: "text",
  },
  {
    title: "退職日",
    keyword: "retireDate",
    type: "text",
  },
  {
    keyword: "check",
    type: "node",
  },
  {
    title: "委任状",
    keyword: "file",
    type: "node",
    showLine: false,
  },
];

export { stepper, fakeTableList };
